export default {
  page: "Men"
};
